import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CbInfoMessageModule, CbLoadingSpinnerModule} from 'cb-hub-lib';
import {CbFormsModule} from '@app/shared/components/forms/forms.module';
import {CbDisplayValueModule} from '@app/shared/components/display-value/display-value.module';
import {CbClickModule} from '@app/shared/directives/click/click.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
    PaymentTemplateEventsComponent
} from '@app/views/settings/pages/payment-template-events/payment-template-events.component';
import {
    PaymentTemplateEventsDialogComponent
} from '@app/views/settings/pages/payment-template-events/components/payment-template-events-dialog.component';

@NgModule({
    declarations: [
        PaymentTemplateEventsComponent,
        PaymentTemplateEventsDialogComponent,

    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbFormsModule,
        CbDisplayValueModule,
        CbClickModule,
        DragDropModule,
    ],
    exports: [
        PaymentTemplateEventsComponent
    ]
})
export class PaymentTemplateEventsSettingsModule { }
